module.exports = __webpack_public_path__ + "static/media/roadmap.7939ab4a.jpg";